import { Services } from '@bode-canada/core';
import routes from '../constants/routes';
import { QueryParams } from '../constants/QueryParams';

const PARAM_SEPARATOR = '-';
const ID_PARAM_POSITION = 0;

export default class PropertyPathHelper {
  static parseIdFromParam(idParam) {
    const id = idParam.split(PARAM_SEPARATOR)[ID_PARAM_POSITION];

    return Number(id);
  }

  static generateReviewRouteFromListing({ listingId }) {
    return `${routes.listingEditing}/${listingId}`;
  }

  static generateDraftRouteFromListing({ listingId }) {
    return `${routes.listHome}?${QueryParams.ListingId}=${listingId}`;
  }

  static generateActiveRouteFromListing({ listingId }) {
    return new Services.BodePathService('', routes).getListingPath(listingId);
  }

  static generateSoldRouteFromListing(params) {
    return new Services.BodePathService('', routes).getSoldPropertyPath(params);
  }
}
